module.exports = __webpack_public_path__ + "static/media/bg_01.f70416d0.jpg";